export default {
  brand: {
    fileShare: '文件分享'
  },
  common: {
    loading: '加載中..',
    confirm: '確認',
    cancel: '取消',
    download: '下載',
    downloadAll: '全部下載',
    downloadSelected: '下載選中',
    selectAll: '全選',
    deselectAll: '取消選中',
    rootDirectory: '根目錄',
    createTime: '創建時間',
    expireTime: '過期時間',
    totalSize: '總大小',
    noFiles: '沒有文件'
  },
  share: {
    expired: '分享的文件已過期',
    invalidLink: '無效的分享鏈接',
    needVerifyCode: '請輸入提取碼',
    verifyCodeLabel: '提取碼',
    verifyCodePlaceholder: '請輸入提取碼',
    extractFiles: '提取文件',
    extractionCodeError: '提取碼錯誤',
    uuidRequestFailed: '下載請求失敗',
    selectFilesFirst: '請先選擇文件',
    unknownError: '未知錯誤'
  },
  error: {
    networkError: '網絡錯誤',
    connectionFailed: '無法連接到分享設備，可能設備關機、休眠或服務區發生變更，請聯繫分享者',
    outdatedLink: '無法連接到分享設備，可能使用了過時的分享鏈接，請聯繫分享者升級系統至v2.0.10版本以上、APP至v2.1.5版本以上，並重新複製分享鏈接',
    registryError: '獲取公網穿透設置錯誤，無法連接到Registry服務',
    missingRegion: '分享鏈接缺少服務區資訊，請聯繫分享者升級系統至v2.0.10版本以上、APP至v2.1.5版本以上，並重新複製分享鏈接'
  }
}
